export default function csrfToken() {
  if (document) {
    const element: HTMLMetaElement = document.head.querySelector("[name=csrf-token]");
    return element.content;
  }
  return "";
}
